import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["suspenseFallback"];
import { renderChildren } from '@superdispatch/ui';
import { Suspense } from 'react';
import { useFormattedPhoneNumber } from "../formatted-phone-number/FormattedPhoneNumber.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function PhoneText(_ref) {
  var {
    phone,
    country,
    fallback,
    format = 'international'
  } = _ref;
  var children = useFormattedPhoneNumber(phone, {
    format,
    country
  });
  return renderChildren(children || fallback);
}
export function SuspendedPhoneText(_ref2) {
  var {
      suspenseFallback = null
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: suspenseFallback,
    children: /*#__PURE__*/_jsx(PhoneText, _objectSpread({}, props))
  });
}